

<!-- <section class="gradient-section-theme-color1">
    <div class="container">
        <h1>
            {{job.name}}
        </h1>
    </div>
</section> -->

<section class="gradient-section-theme-color3">
    <div class="container">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item"><a href="careers">Careers</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{job.name}}</li>
            </ol>
        </nav>

        <div [innerHTML]="job.details"></div>
    </div>
</section>

<section class="bg-light">
    <div class="container">
        <div class="col-xs-12" style="height:50px;"></div>

        <div class="row mb-3">
            <div class="col-2 sm-md-4 themed-grid-col">Type</div>
            <div class="col-6 col-md-4 themed-grid-col"><button type="button"
                    class="btn btn-outline-secondary">{{job.type}}</button></div>
        </div>
        <div class="row mb-3">
            <div class="col-2 sm-md-4 themed-grid-col">Fulltime/Part-time</div>
            <div class="col-6 col-md-4 themed-grid-col"><button type="button"
                    class="btn btn-outline-secondary">{{job.timeType}}</button></div>
        </div>
        <div class="row mb-3">
            <div class="col-2 sm-md-4 themed-grid-col">Location</div>

            <div class="col-6 col-md-4 themed-grid-col">
                @for (location of job.locations; track job.nnid) {
                <button type="button" class="btn btn-outline-secondary">{{location}}</button>&nbsp;
                }
            </div>
        </div>

        <div class="col-xs-12" style="height:50px;"></div>
    </div>
</section>


<section class="py-5">
    <div class="container text-center">
        <p>Follow us on LinkedIn to stay updated with our latest news and job postings!</p>
        <div class="col-xs-12" style="height:50px;"></div>
        <a href="{{SOCIAL_LINK_LINKEDIN}}" target="_blank">
            <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn Logo"
                style="width: 50px; height: auto;">
        </a>
    </div>
</section>

<section class="gradient-section-theme-color2">
    <div class="container">
        For applying to this job, send your application with complete credentials to
        <a href="mailto:{{JOBS_APPLICATION_EMAIL}}">{{JOBS_APPLICATION_EMAIL}}</a>
    </div>
</section>
